import React from 'react';
import { useGetAppointmentTypes } from '../App/customize/hooks/useGetAppointmentTypes';
import startCase from 'lodash.startcase';
import toLower from 'lodash.tolower';

function AppointmentTypesSelect({ handleChange, value, disabled }) {
  const { data: types } = useGetAppointmentTypes({ filter: { checked: 1 } });

  return (
    <select
      name="appointmentType"
      id="species"
      className="form-control form-select "
      disabled={disabled}
      value={value}
      onChange={handleChange}
      required
    >
      <option value="">Select Type</option>
      {types?.map((type) => (
        <option key={type._id} value={type._id}>
          {startCase(toLower(type.title))}
        </option>
      ))}
    </select>
  );
}

export default AppointmentTypesSelect;
